import {
  Autocomplete,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { desc } from "../../../lib/chartDescription";
import {
  useRedditDistributionData,
  useTwitterDistributionData,
} from "../../../lib/hooks";
import {
  listing_options,
  post_catergory_options,
  property_name_options_reddit,
  reddit_table_options,
  time_filter_options,
  tweet_table_name_options,
} from "../../../lib/twitterAPI";
import { roundNumber } from "../../../lib/util";
import styles from "./../../../styles/charts/chartStyle.module.css";
import AreaLineChart from "../protoCharts/AreaLineChart";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "../twitter/TwitterWordCloud";

const property_name_options = [
  { id: "LikesCount", label: "Likes" },
  { id: "RetweetCount", label: "Retweets" },
  { id: "ReplyCount", label: "Replies" },
];

export default function RedditDistribution() {
  const [chartData, setChartData] = useState<{
    data: any[];
  } | null>(null);

  const [distribution, setDistribution] = useState<string | undefined>(
    undefined
  );

  const [propertyName, setpropertyName] = useState(
    property_name_options_reddit[0]
  );

  const [postCategory, setpostCategory] = useState(post_catergory_options[0]);

  const [timeFilter, settimeFilter] = useState(time_filter_options[0]);

  const [listing, setListing] = useState(listing_options[0]);

  const [redditTable, setRedditTable] = useState(reddit_table_options[0]);

  const { distributionData, loading, error } = useRedditDistributionData({
    property_name: propertyName,
    post_category: postCategory,
    time_filter: timeFilter,
    listing,
    reddit_table: redditTable,
  });

  // !loading &&
  //   error === null &&

  // console.log(distributionData);

  useEffect(() => {
    let data: any[] = [];
    if (loading) {
      setChartData({ data: [] });
    }
    if (!loading && error === null) {
      setDistribution(distributionData[0].key);
      distributionData[0].items.forEach((item) => {
        data.push({ x: item[0].toString(), y: roundNumber(item[1]) });
        // console.log(item);
      });
      setChartData({ data });
    }
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    let data: any[] = [];

    distribution !== undefined &&
      distributionData
        .filter((item) => item.key === distribution)[0]
        .items.forEach((item) => {
          data.push({ x: item[0].toString(), y: roundNumber(item[1]) });
        });
    setChartData({ data });
    //eslint-disable-next-line
  }, [distribution]);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter">
          <Typography
            className={styles.chartHeader}
          >{`${propertyName} Distribution of ${postCategory}`}</Typography>
        </div>
        <div className="horizontalCenter">
          <div className={styles.selectOptionRowWordCloud}>
            <Autocomplete
              // autoComplete
              id="combo-box-demo"
              fullWidth
              options={post_catergory_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: string | null) => {
                // setValue(newValue);
                setpostCategory(newValue as string);
                // console.log(newValue);
              }}
              disableClearable
              value={postCategory as string}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // can be used to style  input later on
                  // InputProps={{ style: { fontSize: 14 } }}
                  label="Post Category"
                />
              )}
            />
            <Autocomplete
              // autoComplete
              fullWidth
              id="combo-box-demo"
              options={property_name_options_reddit}
              // isOptionEqualToValue={(option, value) =>
              //   option.label === value.label
              // }
              // sx={{ width: "40%" }}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: any) => {
                // setValue(newValue);
                setpropertyName(newValue);
                // console.log(newValue);
              }}
              disableClearable
              value={propertyName}
              renderInput={(params) => (
                <TextField {...params} label="Select Property" />
              )}
            />
            {["Controversial Posts", "Top Posts", "Keyword Posts"].includes(
              postCategory
            ) && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={time_filter_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  settimeFilter(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={timeFilter as string}
                renderInput={(params) => (
                  <TextField {...params} label="Time Filter" />
                )}
              />
            )}
            {"Keyword Posts" === postCategory && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={listing_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setListing(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={listing as string}
                renderInput={(params) => (
                  <TextField {...params} label="Listing" />
                )}
              />
            )}
            <Autocomplete
              // autoComplete
              fullWidth
              id="combo-box-demo"
              options={reddit_table_options}
              // isOptionEqualToValue={(option, value) =>
              //   option.label === value.label
              // }
              // sx={{ width: "40%" }}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: any) => {
                // setValue(newValue);
                setRedditTable(newValue);
                // console.log(newValue);
              }}
              disableClearable
              value={redditTable}
              renderInput={(params) => (
                <TextField {...params} label="Reddit Table" />
              )}
            />
          </div>
        </div>
        {distribution && (
          <Autocomplete
            // autoComplete
            id="combo-box-demo"
            options={distributionData.map((item) => item.key)}
            // isOptionEqualToValue={(option, value) => option.label === value}
            sx={{ width: "220px" }}
            size={"small"}
            onChange={(event: any, newValue: string | null) => {
              // setValue(newValue);
              setDistribution(newValue as string);
              console.log(newValue);
            }}
            disableClearable
            value={distribution as string}
            renderInput={(params) => (
              <TextField {...params} label="Select Keyword" />
            )}
          />
        )}
        <div style={{ width: "100%" }}>
          <>
            {/* {loading && (
              <Box className={styles.center} sx={{ height: "90%" }}>
                <Typography>Loading...</Typography>
              </Box>
            )} */}
            {chartData && (
              <AreaLineChart
                chartData={[{ name: "data", data: chartData.data }]}
                // labels={chartData.labels}
                xLabel={propertyName}
                yLabel={"Percent"}
                type="area"
                // title={""}
                maxY={100}
                minY={0}
                extraYOffset={15}
              />
            )}
          </>
          {getChartBottomIcons(showMaxButton, setOpen)}
          {getChartInfoIcons(desc["twitter"]["distribution"])}
        </div>
      </Paper>
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
}
